export default __webpack_public_path__ + "static/hero-video-mobile-9fb337c553056d27c00650de5bf3d329.mp4";